import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLocation, useHistory } from "react-router-dom";
import { Constants } from "../../endPoints";
import Checkbox from "@mui/material/Checkbox";

export default function Shopsidebar({ onFilterChange, onClose }) {
  // ---------- State ----------
  const [countries, setCountries] = useState([]);
  const [selections, setSelections] = useState([]);
  const [categories, setCategories] = useState([]);
  const [shopFor, setShopFor] = useState([]);
  const [ringStyle, setRingStyle] = useState([]);
  const [pearlColor, setPearlColor] = useState([]);
  const [pearlType, setPearlType] = useState([]);
  const [diamondColor, setDiamondColor] = useState([]);
  const [clarity, setClarity] = useState([]);
  const [stoneColor, setStoneColor] = useState([]);

  const [openSection, setOpenSection] = useState(null);


  // Selected filters
  const [selectedCountries, setSelectedCountries] = useState([]);
  const [selectedSelections, setSelectedSelections] = useState([]);
  // const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedShopFor, setSelectedShopFor] = useState([]);
  const [selectedRingStyle, setSelectedRingStyle] = useState([]);
  const [selectedPearlColor, setSelectedPearlColor] = useState([]);
  const [selectedPearlType, setSelectedPearlType] = useState([]);
  const [selectedDiamondColor, setSelectedDiamondColor] = useState([]);
  const [selectedClarity, setSelectedClarity] = useState([]);
  const [selectedStoneColor, setSelectedStoneColor] = useState([]);

  // Visibility toggles
  const [isCountryVisible, setIsCountryVisible] = useState(true);
  const [isSelectionVisible, setIsSelectionVisible] = useState(true);
  const [isCategoryVisible, setIsCategoryVisible] = useState(true);
  const [isShopForVisible, setIsShopForVisible] = useState(true);
  const [isRingStyleVisible, setIsRingStyleVisible] = useState(true);
  const [isPearlColorVisible, setIsPearlColorVisible] = useState(true);
  const [isPearlTypeVisible, setIsPearlTypeVisible] = useState(true);
  const [isDiamondColorVisible, setIsDiamondColorVisible] = useState(true);
  const [isClarityVisible, setIsClarityVisible] = useState(true);
  const [isStoneColorVisible, setIsStoneColorVisible] = useState(true);

  const location = useLocation();
  const history = useHistory();
  const [filterCount, setFilterCount] = useState(0);

  const queryParams = new URLSearchParams(location.search);
  const idCountry = queryParams.get("country") || "";
  const idSelection = queryParams.get("selection") || "";
  const idCategory = queryParams.get("category") || "";
  const idShopFor = queryParams.get("shopFor") || "";
  const idRingStyle = queryParams.get("ringStyle") || "";


  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };

  // ---------- Initialize selected filters from URL ----------
  useEffect(() => {
  setSelectedCountries(idCountry ? idCountry.split(",") : []);
  setSelectedSelections(idSelection ? idSelection.split(",") : []);
  // setSelectedCategory(idCategory || null);
  // setSelectedCategory(idCategory ? idCategory.split(",") : []);
  setSelectedCategory(
  idCategory && idCategory !== "null"
    ? idCategory.split(",")
    : []
);
  setSelectedShopFor(idShopFor ? idShopFor.split(",") : []);
}, [idCountry, idSelection, idCategory, idShopFor]);

  // ---------- Fetch Countries ----------
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const res = await axios.get(`${Constants.listCounty}`);
        let list = [];
        if (Array.isArray(res.data)) list = res.data;
        else if (Array.isArray(res.data.data)) list = res.data.data;
        else if (Array.isArray(res.data.list)) list = res.data.list;
        else if (res.data.data?.list && Array.isArray(res.data.data.list))
          list = res.data.data.list;
        setCountries(list);
      } catch (err) {
        console.error("Error fetching countries:", err);
      }
    };
    fetchCountries();
  }, []);

  // ---------- Fetch Selections ----------
  useEffect(() => {
    const fetchSelections = async () => {
      try {
        const res = await axios.get(Constants.listSelection);
        setSelections(res.data.list || []);
      } catch (err) {
        console.error("Error fetching selections:", err);
      }
    };
    fetchSelections();
  }, []);

  // ---------- Fetch Selected Main Selections ----------
  useEffect(() => {
    const fetchSelectedMainSelections = async () => {
      if (!idSelection) return;
      try {
        const res = await axios.get(
          `${Constants.getSelectionById}/${idSelection}`
        );

        if (res.data.status === 1 && Array.isArray(res.data.list)) {
          const ids = res.data.list.map((item) => item.id.toString());
          setSelectedSelections(ids);
        } else if (res.data.status === 1 && res.data.data) {
          setSelectedSelections([res.data.data.id.toString()]);
        }
      } catch (err) {
        console.error("Error fetching main selections:", err);
      }
    };

    fetchSelectedMainSelections();
  }, [idSelection]);

  // ---------- Fetch Categories ----------
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axios.get(
          `${Constants.listCategory}?country=${selectedCountries.join(
            ","
          )}&selection=${selectedSelections.join(",")}`
        );
        setCategories(res.data.list || []);
      } catch (err) {
        console.error("Error fetching categories:", err);
      }
    };
    fetchCategories();
  }, [selectedCountries, selectedSelections]);

  // ---------- Fetch Static Filters ----------
  useEffect(() => {
    const fetchFilters = async () => {
      try {
        const [
          shopRes,
          ringRes,
          pearlCRes,
          pearlTRes,
          diamondRes,
          clarityRes,
          stoneRes,
        ] = await Promise.all([
          axios.get(`${Constants.listShopFor}`),
          axios.get(`${Constants.listRingStyle}`),
          axios.get(`${Constants.listPearlColor}`),
          axios.get(`${Constants.listPearlType}`),
          axios.get(`${Constants.listDiamondColor}`),
          axios.get(`${Constants.listClarity}`),
          axios.get(`${Constants.listStoneColor}`),
        ]);

        setShopFor(shopRes.data.list || []);
        setRingStyle(ringRes.data.list || []);
        setPearlColor(pearlCRes.data.list || []);
        setPearlType(pearlTRes.data.list || []);
        setDiamondColor(diamondRes.data.list || []);
        setClarity(clarityRes.data.list || []);
        setStoneColor(stoneRes.data.list || []);
      } catch (err) {
        console.error("Error fetching filters:", err);
      }
    };
    fetchFilters();
  }, []);

  // ---------- Auto-select "Shop For" based on Main Selection or Category ----------
  // useEffect(() => {
  //   const autoSelectShopFor = async () => {
  //     if (selectedSelections.length === 0 && !selectedCategory) return;

  //     try {
  //       const res = await axios.get(
  //         `${Constants.listProduct}?page=1&limit=100&idSelection=${selectedSelections.join(
  //           ","
  //         )}&idCategory=${selectedCategory || ""}`
  //       );

  //       if (res.data.status === 1 && Array.isArray(res.data.list)) {
  //         const shopForIds = [
  //           ...new Set(
  //             res.data.list
  //               .map((item) => item.idShopFor)
  //               .filter((id) => id !== null && id !== undefined)
  //               .map((id) => id.toString())
  //           ),
  //         ];

  //         if (shopForIds.length > 0) {
  //           // 🧠 Merge with already selected shopFor, not overwrite
  //           setSelectedShopFor((prev) => {
  //             const merged = [...new Set([...prev, ...shopForIds])];

  //             // 🧩 Only update URL if changed
  //             const prevSorted = [...prev].sort().join(",");
  //             const mergedSorted = [...merged].sort().join(",");
  //             if (prevSorted !== mergedSorted) {
  //               updateURL({ shopFor: merged });
  //             }

  //             return merged;
  //           });
  //         }
  //       }
  //     } catch (error) {
  //       console.error("Error auto-selecting shopFor:", error);
  //     }
  //   };

  //   autoSelectShopFor();
  //   // ✅ Do NOT include location.search here to avoid infinite re-renders
  // }, [selectedSelections, selectedCategory]);

  useEffect(() => {
  const autoSelectShopFor = async () => {
    // ❌ If user already selected something → DO NOTHING
    if (selectedShopFor.length > 0) return;

    if (selectedSelections.length === 0 && !selectedCategory?.length) return;

    try {
      const res = await axios.get(
        `${Constants.listProduct}?page=1&limit=100&idSelection=${selectedSelections.join(",")}&idCategory=${(selectedCategory || []).join(",")}`
      );

      if (res.data.status === 1 && Array.isArray(res.data.list)) {
        const shopForIds = [
          ...new Set(
            res.data.list
              .map((item) => item.idShopFor)
              .filter(Boolean)
              .map((id) => id.toString())
          ),
        ];

        if (shopForIds.length > 0) {
          setSelectedShopFor(shopForIds);
          updateURL({ shopFor: shopForIds });
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  autoSelectShopFor();
}, [selectedSelections, selectedCategory]);


  // ---------- URL + Checkbox Handling ----------
  const updateURL = (newParams) => {
    const currentParams = new URLSearchParams(location.search);

    const allParams = {
      country: selectedCountries,
      selection: selectedSelections,
      // category: selectedCategory ? [selectedCategory] : [],
      category: selectedCategory,
      shopFor: selectedShopFor,
      ringStyle: selectedRingStyle,
      pearlColor: selectedPearlColor,
      pearlType: selectedPearlType,
      diamondColor: selectedDiamondColor,
      clarity: selectedClarity,
      stoneColor: selectedStoneColor,
      ...newParams,
    };

    Object.entries(allParams).forEach(([key, values]) => {
      if (!values || values.length === 0) currentParams.delete(key);
      else currentParams.set(key, [...new Set(values)].join(","));
    });

    history.replace({ search: currentParams.toString() });
  };
  // useEffect(() => {
  //   onFilterChange && onFilterChange({
  //     countries: selectedCountries.length > 0,
  //     selections: selectedSelections.length > 0,
  //     category: !!selectedCategory,
  //     shopFor: selectedShopFor.length > 0
  //   });
  // }, [selectedCountries, selectedSelections, selectedCategory, selectedShopFor]);
  useEffect(() => {

    const count =
      selectedCountries.length +
      selectedSelections.length +
      // (selectedCategory ? 1 : 0) +
      (selectedCategory || []).length +
      selectedShopFor.length +
      selectedRingStyle.length +
      selectedPearlColor.length +
      selectedPearlType.length +
      selectedDiamondColor.length +
      selectedClarity.length +
      selectedStoneColor.length;
    setFilterCount(count);

    onFilterChange && onFilterChange(
      {
        countries: selectedCountries.length > 0,
        selections: selectedSelections.length > 0,
        category: !!selectedCategory,
        shopFor: selectedShopFor.length > 0
      },
      count
    );

  }, [
    selectedCountries,
    selectedSelections,
    selectedCategory,
    selectedShopFor,
    selectedRingStyle,
    selectedPearlColor,
    selectedPearlType,
    selectedDiamondColor,
    selectedClarity,
    selectedStoneColor
  ]);

  const handleCheckboxChange = (setState, value, key) => {
    const val = value.toString();
    setState((prev) => {
      const updated = prev.includes(val)
        ? prev.filter((v) => v !== val)
        : [...prev, val];
      updateURL({ [key]: updated });
      onFilterChange && onFilterChange({
        countries: key === "country" ? updated.length > 0 : selectedCountries.length > 0,
        selections: key === "selection" ? updated.length > 0 : selectedSelections.length > 0,
        category: !!selectedCategory,
        shopFor: key === "shopFor" ? updated.length > 0 : selectedShopFor.length > 0
      });
      return updated;
    });
  };

  // const handleCategoryChange = (categoryId) => {
  //   setSelectedCategory(categoryId);
  //   updateURL({ category: [categoryId] });
  // };

  // ---------------- Render ----------------
  return (
    <>
      <div className="accordion" id="accordionExample">

        {/* COUNTRY */}
        <div className="accordion-item">
          <button
            className={`accordion-button ${openSection === "country" ? "" : "collapsed"}`}
            type="button"
            onClick={() => toggleSection("country")}
          >
            Country ({countries.length})
            <i>
              {/* <img src="assets/images/right_arow.svg" alt="" /> */}
              <img src={`${process.env.PUBLIC_URL}/assets/images/right_arow.svg`} alt="" />
            </i>
          </button>

          <div
            className={`accordion-collapse collapse ${openSection === "country" ? "show" : ""}`}
          >
            <div className="accordion-body">

              {countries.map((c) => (
                <div className="chesklst" key={c.id}>
                  <input
                    type="checkbox"
                    id={`country-${c.id}`}
                    checked={selectedCountries.includes(c.id.toString())}
                    onChange={() =>
                      handleCheckboxChange(setSelectedCountries, c.id, "country")
                    }
                  />

                  <label htmlFor={`country-${c.id}`}>
                    {c.country_symbols && (
                      <i>
                        <img
                          src={c.country_symbols}
                          alt={c.country}
                          style={{ width: 20 }}
                        />
                      </i>
                    )}
                    {c.country}
                  </label>
                </div>

              ))}

            </div>
          </div>
        </div>

        {/* MAIN SELECTION */}
        <div className="accordion-item">
          <button
            className={`accordion-button ${openSection === "selection" ? "" : "collapsed"}`}
            onClick={() => toggleSection("selection")}
          >
            Main Selection ({selections.length})
            <i>
              <img src={`${process.env.PUBLIC_URL}/assets/images/right_arow.svg`} alt="" />
            </i>
          </button>

          <div className={`accordion-collapse collapse ${openSection === "selection" ? "show" : ""}`}>
            <div className="accordion-body">
              <div className="categoryFilter">

                {selections.map((item) => (
                  <div className="chesklst" key={item.id}>
                    <input
                      type="checkbox"
                      id={`selection-${item.id}`}
                      checked={selectedSelections.includes(item.id.toString())}
                      onChange={() =>
                        handleCheckboxChange(setSelectedSelections, item.id, "selection")
                      }
                    />

                    <label htmlFor={`selection-${item.id}`}>
                      {item.image && (
                        <i>
                          <img
                            src={`${Constants.imageBaseURL}${item.image}`}
                            alt={item.name}
                          />
                        </i>
                      )}
                      {item.name}
                    </label>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* CATEGORY */}
        <div className="accordion-item">
          <button
            className={`accordion-button ${openSection === "category" ? "" : "collapsed"}`}
            type="button"
            onClick={() => toggleSection("category")}
          >
            Category ({categories.length})
            <i>
              <img src={`${process.env.PUBLIC_URL}/assets/images/right_arow.svg`} alt="" />
            </i>
          </button>

          <div
            className={`accordion-collapse collapse ${openSection === "category" ? "show" : ""}`}
          >
            <div className="accordion-body">
              {categories.map((item) => (
                <div className="chesklst" key={item.id}>
                  <input
                    type="checkbox"
                    id={`category-${item.id}`}
                    checked={selectedCategory.includes(item.id.toString())}
onChange={() =>
  handleCheckboxChange(setSelectedCategory, item.id, "category")
}
                  />

                  <label htmlFor={`category-${item.id}`}>
                    {item.image && (
                      <i>
                        <img
                          src={`${Constants.imageBaseURL}${item.image}`}
                          alt={item.name}
                        />
                      </i>
                    )}
                    {item.name}
                  </label>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* SHOP FOR */}
        <div className="accordion-item">
          <button
            className={`accordion-button ${openSection === "shopFor" ? "" : "collapsed"}`}
            type="button"
            onClick={() => toggleSection("shopFor")}
          >
            Shop For ({shopFor.length})
            <i>
              <img src={`${process.env.PUBLIC_URL}/assets/images/right_arow.svg`} alt="" />
            </i>
          </button>

          <div
            className={`accordion-collapse collapse ${openSection === "shopFor" ? "show" : ""}`}
          >
            <div className="accordion-body">
              {shopFor.map((item) => (
                <div className="chesklst" key={item.id}>
                  <input
                    type="checkbox"
                    id={`shopfor-${item.id}`}
                    checked={selectedShopFor.includes(item.id.toString())}
                    onChange={() =>
                      handleCheckboxChange(setSelectedShopFor, item.id, "shopFor")
                    }
                  />
                  <label htmlFor={`shopfor-${item.id}`}>
                    {item.name}
                  </label>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* MOBILE BUTTONS */}
      <div className="miblebtnbtm">
        <ul>
          <li>
            <a
              href="#"
              className="closeFilter"
              onClick={(e) => {
                e.preventDefault();
                onClose && onClose();
              }}
            >
              Close
            </a>
          </li>
          <li>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                onClose && onClose();
              }}
            >
              Apply {filterCount > 0 && `(${filterCount})`}
            </a>
          </li>
        </ul>
      </div>
    </>
  );
}

// ---------- Reusable Filter Section ----------
const FilterSection = ({
  title,
  visible,
  toggle,
  data,
  selected,
  setSelected,
  param,
}) => (
  <div className="border mb-4">
    <h2
      className="px-4 py-3 bg-gray-100 uppercase font-semibold tracking-wider cursor-pointer"
      onClick={toggle}
    >
      {title}
    </h2>
    {visible && (
      <div className="max-h-72 overflow-auto p-2 scroll-light">
        {data.map((item) => (
          <label key={item.id} className="flex gap-3 items-center">
            <Checkbox
              checked={selected.includes(item.id.toString())}
              onChange={() =>
                setSelected((prev) => {
                  const val = item.id.toString();
                  const updated = prev.includes(val)
                    ? prev.filter((v) => v !== val)
                    : [...prev, val];
                  const params = new URLSearchParams(window.location.search);
                  params.set(param, [...new Set(updated)].join(","));
                  window.history.replaceState({}, "", `?${params.toString()}`);
                  return updated;
                })
              }
              sx={{ "& .MuiSvgIcon-root": { fontSize: 19 } }}
            />
            {item.name}
          </label>
        ))}
      </div>
    )}
  </div>
);
